// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bordetitulo {
  height: 1px;
  width: 100%;
  background-color: #450d1c;
}

p {
  word-wrap: break-word !important;
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
}

a p {
  color: #6E374B;
}

a p:hover, a:hover {
  color: #BE1111;
  transition: all 0.3s ease-in;
}

.btn-success {
  background-color: #73D313;
  color: #fff;
  border-radius: 8px;
  border-color: #73D313;
  transition: all 0.3s ease-in;
  min-height: inherit;
  padding: 0.025rem 0 0 0.1rem;
  width: 1.5rem;
  height: 1.5rem;
}

.btn-success img {
  width: 70%;
  height: 70%;
  font-size: small;
  margin-bottom: 5px;
  margin-right: 2px;
}

.btn-success:active, .btn-success:focus, .btn-success:hover {
  background-color: #62B113 !important;
  border-color: #62B113 !important;
  transition: all 0.3s ease-in;
  color: #fff !important;
}

.mat-mdc-raised-button > .mat-icon {
  width: 36px;
  height: 36px;
  padding: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
